import * as stylex from "@stylexjs/stylex";
import "@/theme/tokens.stylex";
import { colors } from "@/theme/tokens.stylex";
import "@/theme/type.stylex";
import { type } from "@/theme/type.stylex";
type SliderProps = {
  label: string;
  min: number;
  max: number;
  value: number;
  valueText: string;
  minLabel: string;
  maxLabel: string;
  onChange: (value: number) => void;
  disabled?: boolean;
};
export function Slider({
  label,
  min,
  max,
  value,
  valueText,
  minLabel,
  maxLabel,
  onChange,
  disabled = false
}: SliderProps) {
  return <div className="x78zum5 xdt5ytf">
      <input type="range" min={min} max={max} step={1} value={value} disabled={disabled} aria-label={label} aria-valuetext={valueText} onChange={event => onChange(Number(event.target.value))} {...{
      0: {
        className: "xh8yej3 xn3w4p2 x1ghz6dp xchfsw0 x1ypdohk"
      },
      1: {
        className: "xh8yej3 xn3w4p2 x1ghz6dp xtrc2dy xt0e3qv"
      }
    }[!!disabled << 0]} />
      <div aria-hidden="true" className="x78zum5 x1qughib xr0iwhn xhunfcg xt3et7w xtvhhri">
        <span>{minLabel}</span>
        <span>{maxLabel}</span>
      </div>
    </div>;
}